import { Reducer } from 'redux'

import { IFoldersState } from '../states/folders.state'
import { folderInitialState, IFolderModel } from '../../models/folder.model'

import * as fromActions from '../actions/folders.action'

export const initialState: IFoldersState = {
  list: [],
  folder: folderInitialState,
  loading: false,
}

export const reducer: Reducer<IFoldersState> = (
  state: IFoldersState = initialState,
  { type, payload }
) => {
  switch (type) {
    case fromActions.FOLDERS_ADMINISTRATION_LIST:
      return {
        ...state,
        loading: true,
      }

    case fromActions.FOLDERS_ADMINISTRATION_LIST_SUCCESS: {
      const { data: list } = payload
      return {
        ...state,
        list,
        loading: false,
      }
    }

    case fromActions.DESTROY_FOLDER:
      return {
        ...state,
        loading: true,
      }

    case fromActions.CREATE_FOLDER:
      return {
        ...state,
        loading: true,
      }

    case fromActions.UPDATE_FOLDER:
      return {
        ...state,
        loading: true,
      }

    case fromActions.UPDATE_FOLDER_SUCCESS: {
      const data: IFolderModel = payload.data
      return {
        ...state,
        list: state.list.map((folder) => {
          if (folder.id === data.id) return data
          return folder
        }),
      }
    }

    case fromActions.ASSIGN_COURSE:
      return {
        ...state,
        loading: true,
      }

    case fromActions.ORDER_FOLDER:
      return {
        ...state,
        loading: true,
      }
    case fromActions.LOADING_FOLDER:
      return {
        ...state,
        loading: payload,
      }

    default:
      return state
  }
}
